import { createTranslations } from '@npco/utils-translations'

export const noBusinessResultTranslations = createTranslations({
  title: 'No Businesses Found',
  description: "You haven't linked any business with that name.",
})
